import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import { connect } from 'react-redux'
import TemplateImageLoader from '~/pages/cp/automation/addNew/templateImageLoader.jsx'
import helpers from '~/Classes/helpers'
import WysiwygEditor from '~/pages/cp/templates/add/dragDrop/rightTools/elementEditor/components/wysiwyg'
@connect((store) => {
    return { accountMaster: store.accountMaster }
})
class FormConfirm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {}
        }
        this.updateField = this.updateField.bind(this)
        this.checkForm = this.checkForm.bind(this)
        this.edit = this.edit.bind(this)
        this.next = this.next.bind(this)
    }

    componentDidMount() {
        this.checkForm()
    }

    updateField(ev, options) {
        var form = this.props.form
        if (options) {
            form.options[ev.currentTarget.name] = ev.currentTarget.value
        } else {
            form[ev.currentTarget.name] = ev.currentTarget.value
        }
        this.checkForm()
        this.props.update()
    }

    checkForm() {
        var errors = {}
        var options = this.props.form.options
        if (options.onCreate === 'redirect') {
            if (!options.createRedirectUrl) {
                errors.createRedirectUrl = i18n.t('form:step2.errUrl')
            } else if (
                options.createRedirectUrl.toLowerCase().indexOf('http://') < 0 &&
                options.createRedirectUrl.toLowerCase().indexOf('https://') < 0
            ) {
                errors.createRedirectUrl = i18n.t('form:step2.errUrlHttp')
            }
        }
        if (options.onCreate === 'message' && !options.createMessage)
            errors.createMessage = i18n.t('form:step2.errMessage')

        this.setState({
            errors
        })
    }

    edit() {
        const isUsingNewEditor = helpers.getTemplateEditorVersion(this.props.accountMaster, true)
        this.props.save().then(() => {
            var redirect = '/cp/groups/' + this.props.groupId + '/forms/create/' + this.props.form.id + '/3'
            const editorUrl = isUsingNewEditor.canUseV2
                ? '/cp/templates/add/dragDropv2/'
                : '/cp/templates/add/dragDrop/'

            this.props.history.push(
                editorUrl +
                    '?form=true&groupId=' +
                    this.props.groupId +
                    '&formId=' +
                    this.props.form.id +
                    '&redirect=' +
                    redirect +
                    '&page=created'
            )
        })
    }

    next() {
        this.props.form.wizard.step2 = true
        this.props.update()
        if (this.props.form.options.onCreate === 'replace') {
            this.edit()
        } else {
            this.props.changeStep(3, true)
        }
    }

    render() {
        return (
            <div>
                <Row>
                    <Column xs={12} md={4} className='mar-b25'>
                        <div
                            className='campaign-thumbnail'
                            style={{ width: '100%', height: '100%', minHeight: '150px' }}
                        >
                            <TemplateImageLoader
                                imageUrl={this.props.screenshotUrl}
                                form={this.props.form.formType === 1}
                            />
                        </div>
                    </Column>
                    <Column xs={12} md={8}>
                        <Paper>
                            <h4 className='mar-b25'>{i18n.t('form:step2.header')}</h4>

                            <Select
                                outerClassName='mar-b25'
                                name='onCreate'
                                value={this.props.form.options.onCreate}
                                data={[
                                    { label: i18n.t('form:step2.message'), value: 'message' },
                                    {
                                        label: i18n.t('form:step2.redirect'),
                                        value: 'redirect',
                                        disabled:
                                            this.props.form.options?.serve === 'click' ||
                                            this.props.form.options?.serve === 'clickButton'
                                    },
                                    {
                                        label: i18n.t('form:step2.hideForm'),
                                        value: 'hide',
                                        disabled:
                                            this.props.form.options?.serve === 'click' ||
                                            this.props.form.options?.serve === 'clickButton'
                                    }
                                ]}
                                onChange={(ev) => this.updateField(ev, true)}
                            />

                            {this.props.form.options.onCreate !== 'replace' && (
                                <div>
                                    {this.props.form.options.onCreate == 'redirect' && (
                                        <TextInput
                                            outerClassName='mar-b25'
                                            value={this.props.form.options.createRedirectUrl}
                                            error={this.state.errors.createRedirectUrl}
                                            placeholder={i18n.t('form:step2.url')}
                                            name='createRedirectUrl'
                                            onChange={(ev) => this.updateField(ev, true)}
                                            id='redirect'
                                            mergeTags={true}
                                        />
                                    )}
                                    {this.props.form.options.onCreate == 'message' && (
                                        <TextInput
                                            outerClassName='mar-b25'
                                            value={this.props.form.options.createMessage}
                                            error={this.state.errors.createMessage}
                                            placeholder={i18n.t('form:step2.success')}
                                            name='createMessage'
                                            onChange={(ev) => this.updateField(ev, true)}
                                        />
                                    )}
                                    {this.props.form.options.onCreate == 'hide' && (
                                        <>
                                            <WysiwygEditor
                                                updateVal={(notUsed, theValue) => {
                                                    this.updateField(
                                                        {
                                                            currentTarget: {
                                                                name: 'createMessage',
                                                                value: theValue
                                                            }
                                                        },
                                                        true
                                                    )
                                                }}
                                                additionalTools={[
                                                    'fontsizeselect',
                                                    'fontselect',
                                                    'bullist',
                                                    'numlist',
                                                    'mpzColorPicker'
                                                ]}
                                                AutomationId={null}
                                                hasWorkflowEmails={false}
                                                wysiwygMode='simple'
                                                wysiwygHeight='200px'
                                                standalone={true}
                                                name='createMessage'
                                                placeholder={i18n.t('form:step2.success')}
                                                error={this.state.errors.createMessage}
                                                value={this.props.form.options.createMessage}
                                                globalColours={[]}
                                                favoriteColors={[]}
                                            />
                                        </>
                                    )}
                                </div>
                            )}
                        </Paper>
                    </Column>
                </Row>
                <div className='quickFlex end-xs'>
                    <Button
                        className='button-primary'
                        iconRight={<Icons icon='arrowRight' />}
                        disabled={!!Object.keys(this.state.errors).length}
                        text={
                            this.props.form.options.onCreate === 'replace'
                                ? i18n.t('form:step2.create')
                                : i18n.t('form:step2.next')
                        }
                        onClick={this.next}
                    />
                </div>
            </div>
        )
    }
}

export default FormConfirm
